<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
      @if (tooltipKey()) {
        <app-directus-tooltip class="ml-2" [tooltipKey]="tooltipKey()" />
      }
    </label>
  }

  @if (isReadOnly()) {
    <input pInputText [value]="value() ?? ''" [disabled]="true" class="w-full readOnly" />
  } @else {
    <input
      pInputText
      [id]="id()"
      [attr.data-testid]="id() + '-input'"
      [(ngModel)]="value"
      [placeholder]="placeholder() || label() | transloco"
      [ngClass]="{'p-invalid': isInvalid()}"
      class="w-full"
      (blur)="markAsTouched()"
    />
  }
</div>
